/**
 * Cart Drawer Header Integration
 * 
 * This file provides the integration between the header cart icon and the cart drawer.
 * The cart-drawer custom element is defined in sections/cart-drawer.liquid.
 * 
 * This script only handles:
 * - Header cart icon click to open drawer
 * - Optional: refresh drawer after add-to-cart from product pages
 */

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartDrawerIntegration);
} else {
  initCartDrawerIntegration();
}

function initCartDrawerIntegration() {
  // Setup header cart icon(s)
  setupCartIcons();
  
  // Setup add-to-cart refresh (optional)
  setupAddToCartRefresh();
}

function setupCartIcons() {
  const cartIcons = [
    document.querySelector('#cart-icon-bubble'),
    document.querySelector('#cart-icon-bubble-mobile')
  ].filter(Boolean);
  
  cartIcons.forEach(cartIcon => {
    if (!cartIcon) return;
    
    cartIcon.setAttribute('role', 'button');
    cartIcon.setAttribute('aria-haspopup', 'dialog');
    
    cartIcon.addEventListener('click', (event) => {
      event.preventDefault();
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    });
    
    cartIcon.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }
    });
  });
}

function getCartUrl() {
  const configEl = document.getElementById('CartDrawer-Config');
  if (configEl) {
    try {
      const config = JSON.parse(configEl.textContent);
      if (config.routes && config.routes.cart) return config.routes.cart;
    } catch (e) {}
  }
  return '/cart';
}

async function fetchCartJson(cartUrl) {
  const res = await fetch(cartUrl, { headers: { 'Accept': 'application/json' } });
  const text = await res.text();
  if (!text || !text.trim()) throw new Error('Empty cart response');
  try {
    return JSON.parse(text);
  } catch (e) {
    throw new Error('Invalid cart response');
  }
}

function setupAddToCartRefresh() {
  // Listen for custom add-to-cart events from product forms
  document.addEventListener('cart:item-added', async () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    
    try {
      const cartUrl = getCartUrl() + (getCartUrl().endsWith('.js') ? '' : '.js');
      const cart = await fetchCartJson(cartUrl);
      
      // Call refreshFromCart if available, otherwise open the drawer
      if (typeof cartDrawer.refreshFromCart === 'function') {
        cartDrawer.refreshFromCart(cart);
      } else if (typeof cartDrawer.updateCartUI === 'function') {
        cartDrawer.updateCartUI(cart);
      }
      
      // Open the drawer to show the newly added item
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    } catch (err) {}
  });
}
